module.exports = __webpack_public_path__ + "img/settings_white.2bf2a5b2.svg";